import { ButtonBase } from '@mui/material';
import { useTheme } from '@mui/styles';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import React from 'react';
import ListEmpty from '../fragments/ListEmpty';
import ListLoading from '../fragments/ListLoading';
import { googleMapsApiKey } from '../../utils/environment';

const containerStyle = {
    width: `100%`,
    height: `100%`,
    borderRadius: 10,
};

function EventMap({ location }) {
    const theme = useTheme();

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey,
    });

    return (
        <>
            <ButtonBase
                className="w-100 my-2"
                style={{
                    borderRadius: theme.shape.borderRadius,
                    height: 200,
                }}
            >
                {loadError && <ListEmpty title="Could not load map" />}
                {!isLoaded && <ListLoading />}
                {isLoaded && (
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={location}
                        zoom={8}
                    >
                        <Marker position={location} />
                    </GoogleMap>
                )}
            </ButtonBase>
        </>
    );
}

export default React.memo(EventMap);
